import { Yup, TRANSLATION} from '@/imports-files/components/model/custom-company-integration-modal.js';

const DomainMatch = /^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg;

export const CONSTANTS = {
                            formInitialValues: {
                                                    custom_integration:{
                                                                            name:'',
                                                                            domain:'',
                                                                            category:''
                                                                       }
                                               },
                            formValidations:  Yup.object({
                                                            custom_integration: Yup.object({
                                                                                                name       :   Yup.string().required(TRANSLATION('common:errors:required')).nullable(true),
                                                                                                domain     :   Yup.string().required(TRANSLATION('common:errors:required')).matches(DomainMatch, 'Please enter correct domain'),
                                                                                                category   :   Yup.string().required(TRANSLATION('common:errors:required'))
                                                                                           })
                                                        }),

                                                        indeedModal: {
                                                          heading: "Authentication",
                                                          description:
                                                            "Please enter the necessary details to complete the connection process with the job board.",
                                                            
                                                          inputs: [
                                                            {
                                                              label: "Company Name",
                                                              type: "text",
                                                              tooltip:
                                                                "Ensure this matches the exact company name registered on Indeed. Any mismatch may prevent your jobs from appearing in the correct sponsored campaign on Indeed.",
                                                              name: "company_name",
                                                              placeholder: "Enter Company Name",
                                                            },
                                                            {
                                                              label: "Indeed Campaign Tag",
                                                              type: "text",
                                                              tooltip:
                                                                "This tag helps identify and link jobs to a specific sponsored campaign on Indeed. Ensure it matches the campaign tag set up in your Indeed account.",
                                                              name: "campaign_tag",
                                                              placeholder: "Enter Indeed Compaign",
                                                            },
                                                          ],
                                                      
                                                          validationSchema: Yup.object().shape({
                                                            company_name: Yup.string()
                                                              .required("Company name is required")
                                                              .nullable(true),
                                                          }),
                                                        },
                                                        totalJobsModal: {
                                                          heading: "Authentication",
                                                          description:
                                                            "Please enter the necessary details for TotalJobs to complete the connection process with the job board.",
                                                      
                                                          inputs: [
                                                            {
                                                              label: "TotalJobs Feed Username",
                                                              name: "user_name",
                                                              type: "text",
                                                              placeholder: "TotalJobs Feed Username",
                                                              tooltip: "Ensure this matches the exact username registered on TotalJobs. Any mismatch may prevent your jobs from appearing on the job board.",
                                                            },
                                                            {
                                                              label: "Password",
                                                              name: "password",
                                                              type: "password",
                                                              placeholder: "Enter Password",
                                                              tooltip: "Enter the correct password associated with the username above to establish the connection and post jobs on the job board.",
                                                            },
                                                          ],
                                                        },

                                                        linkedInJobsModal: {
                                                          heading: "Authentication",
                                                          description:
                                                            "Please enter the necessary details to complete the connection process with the job board.",
                                                          radios: [
                                                            {
                                                              text: " LinkedIn Jobs Basic",
                                                              defaultvalue: "true",
                                                              id: 'obtainCompanyId',
                                                              checked: "true",
                                                            },

                                                            {
                                                              text: "LinkedIn Jobs Premium",
                                                              defaultvalue: "false",
                                                              id: 'obtainCompanyId',
                                                              checked: "false",
                                                            }
                                                              
                                                          ],
                                                          
                                                          inputs: [
                                                            {
                                                              label: "Company ID",
                                                              name: "company_id",
                                                              placeholder: "Enter Company ID",
                                                              // description:"To obtain your Company ID, please refer to the guide here for step-by-step instructions on how to access and view it.",
                                                              description: 'obtainCompanyId'
                                                            },
                                                            {
                                                              label: "Contract ID",
                                                              name: "contract_id",
                                                              placeholder: "Contract ID",
                                                              description: 'obtainContractId',
                                                            },
                                                          ],
                                                      
                                                          validationSchema: Yup.object().shape({
                                                            company_id: Yup.string()
                                                              .required("Company ID is required")
                                                              .nullable(),
                                                          })
                                                        },

                                                        modalMap : { 
                                                          "CV-Library Paid": "cvLibraryPaid",
                                                          "Indeed": "indeed",
                                                          "LinkedIn Jobs": "linkedInJobs",
                                                          "Total Jobs": "totalJobs",
                                                        }
                                                        
}

export function integrationValidationSchema(
  isAccountConnected,
  connectModal,
  selectedRadio
) {
  if (connectModal === "indeed") {
    return Yup.object({
      company_name: Yup.string().required("Company name is required").nullable(true),
    });
  }

  if (selectedRadio === "false") {
    return Yup.object({
      company_id: Yup.string().required("Company ID is required").nullable(true),
      contract_id: Yup.string()
        .required("Contract ID is required")
        .when([], {
          is: () => isAccountConnected,
          then: Yup.string().required("Contract ID is required").nullable(),
          otherwise: Yup.string().nullable(),
        }),
    });
  }

  if (connectModal === "totalJobs") {
    return Yup.object({
      user_name: Yup.string().required("TotalJobs feed username is required").nullable(true),
      password: Yup.string().required("Password is required").nullable(true),
    });
  }

  return Yup.object({
    company_id: Yup.string().required("Company ID is required").nullable(true),
  });
}
